export enum CreateProjectState {
    IDLE = 'IDLE',
    DIALOG_OPEN = 'DIALOG_OPEN',
    IN_PROGRESS = 'IN_PROGRESS'
}
